import { BugoBrand, BugoBrandData } from '@shared/api/bugoBrand/bugoBrand.interface';
import { adminCreateUser, adminUpdateUser } from '@shared/api/user/user.controller';
import { UserRole } from '@shared/types';

import {
  BugoBrandAgencyWorkerFormInputs,
  BugoBrandAgencyWorkerFormInputsEnum,
} from './AdminBugoBrandAgencyWorkerForm.interface';

//* 지도사 계정 생성 dto — 단건 폼·일괄 발급이 같이 쓴다
export const buildAgencyWorkerCreateDto = (
  data: BugoBrandAgencyWorkerFormInputs & { username: string; password: string },
  bugoBrand: BugoBrand | BugoBrandData,
) => {
  return {
    username: data.username,
    password: data.password,
    roles: [UserRole.BugoAgencyWorker, UserRole.StoreCustomer],
    info: {
      name: data[BugoBrandAgencyWorkerFormInputsEnum.Name],
      gender: '',
      birth: '',
      phoneNumber: data[BugoBrandAgencyWorkerFormInputsEnum.PhoneNumber],
      theme: data[BugoBrandAgencyWorkerFormInputsEnum.Theme],
    },
    bugoBrand: bugoBrand._id,
    bugoAgencyWorkerDetail: {
      cemeteryList: [],
      region: data[BugoBrandAgencyWorkerFormInputsEnum.Region],
      teamType: data[BugoBrandAgencyWorkerFormInputsEnum.TeamType],
      teamName: data[BugoBrandAgencyWorkerFormInputsEnum.TeamName],
      giftPilot: data[BugoBrandAgencyWorkerFormInputsEnum.GiftPilot],
    },
  };
};

//*bugoBrandAgencyWorker Upsert 함수
export const onAgencyWorkerUpsert = async (
  data: BugoBrandAgencyWorkerFormInputs,
  bugoBrand: BugoBrand | BugoBrandData,
  editMode: boolean,
  agencyWorkerId?: string,
) => {
  //수정
  if (editMode && agencyWorkerId) {
    const bugoBrandAgencyWorkerDto = {
      _id: agencyWorkerId,
      'info.name': data[BugoBrandAgencyWorkerFormInputsEnum.Name],
      'info.phoneNumber': data[BugoBrandAgencyWorkerFormInputsEnum.PhoneNumber],
      'info.theme': data[BugoBrandAgencyWorkerFormInputsEnum.Theme],
      'bugoAgencyWorkerDetail.teamType':
        data[BugoBrandAgencyWorkerFormInputsEnum.TeamType],
      'bugoAgencyWorkerDetail.teamName':
        data[BugoBrandAgencyWorkerFormInputsEnum.TeamName],
      'bugoAgencyWorkerDetail.region': data[BugoBrandAgencyWorkerFormInputsEnum.Region],
      'bugoAgencyWorkerDetail.giftPilot':
        data[BugoBrandAgencyWorkerFormInputsEnum.GiftPilot],
    };
    const agencyWorkerUserUpdated = await adminUpdateUser(bugoBrandAgencyWorkerDto);
    return agencyWorkerUserUpdated;
  }
  // 생성
  else {
    const username = data[BugoBrandAgencyWorkerFormInputsEnum.UserName];
    const password = data[BugoBrandAgencyWorkerFormInputsEnum.Password];
    if (username && password) {
      const bugoBrandAgencyWorkerCreateDto = buildAgencyWorkerCreateDto(
        { ...data, username, password },
        bugoBrand,
      );

      // 팀장 user 생성
      const agencyAdminWorkerCreated = await adminCreateUser(
        bugoBrandAgencyWorkerCreateDto,
      );

      return agencyAdminWorkerCreated;
    }
  }
};
